import React from 'react'
import VerticalStepper from '../GenerateBill/VerticalStepper'

const GenerateBill = () => {
  return (
    <VerticalStepper />
  )
}

export default GenerateBill